const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : ApiDigitaltTilsyn
 */

function ApiDigitaltTilsyn(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

ApiDigitaltTilsyn.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_ApiDigitaltTilsyn = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const ApiDigitaltTilsyn_null_default = new StateJS.State('default', this._statemachine);
  _initial_ApiDigitaltTilsyn.to(ApiDigitaltTilsyn_null_default);
  ApiDigitaltTilsyn_null_default.on(Event.StopStream).when((stopStream) => stopStream.port === 'api' && stopStream.type === 'stopStream').effect((stopStream) => {
    this.stopStream(stopStream.cameraId, stopStream.streamId);
  });
  ApiDigitaltTilsyn_null_default.on(Event.StartStream).when((startStream) => startStream.port === 'api' && startStream.type === 'startStream').effect((startStream) => {
    this.startStream(startStream.cameraId, startStream.ttl, startStream.profile);
  });
  ApiDigitaltTilsyn_null_default.on(Event.KeepStreamAlive).when((keepStreamAlive) => keepStreamAlive.port === 'api' && keepStreamAlive.type === 'keepStreamAlive').effect((keepStreamAlive) => {
    this.keepStreamAlive(keepStreamAlive.cameraId, keepStreamAlive.streamId, keepStreamAlive.ttl);
  });
};
ApiDigitaltTilsyn.prototype.timestamp = function () {
  return Date.now();
};

ApiDigitaltTilsyn.prototype.dispatchError = function (ApiDigitaltTilsyn_dispatchError_err_var) {
  const err = ApiDigitaltTilsyn_dispatchError_err_var;
  if (err && err.message && (err.message.includes('Unable to retrieve stream') || err.message.includes('Stream unavailable'))) {
    this.bus.emit('api', new Event.ErrorStreamUnavailable_ApiDigitaltTilsynMsg(this.name, 'api'));
  } else {
    this.bus.emit('api', new Event.ErrorTechnical_ApiDigitaltTilsynMsg(this.name, 'api'));
  }
};

ApiDigitaltTilsyn.prototype.check = function (ApiDigitaltTilsyn_check_cameraId_var) {
  if ((!ApiDigitaltTilsyn_check_cameraId_var)) {
    this.bus.emit('api', new Event.UnrecoverableError_ApiDigitaltTilsynMsg(this.name, 'api', 'cameraId is null'));
    return false;
  }
  if ((!this.ApiDigitaltTilsyn_client_var)) {
    this.bus.emit('api', new Event.UnrecoverableError_ApiDigitaltTilsynMsg(this.name, 'api', 'Apollo client is null'));
    return false;
  }
  return true;
};

ApiDigitaltTilsyn.prototype.startStream = function (ApiDigitaltTilsyn_startStream_cameraId_var, ApiDigitaltTilsyn_startStream_ttl_var, ApiDigitaltTilsyn_startStream_profile_var) {
  if (!(this.check(ApiDigitaltTilsyn_startStream_cameraId_var))) {
    return;
  }
  const startedAt_var = this.timestamp();
  this.ApiDigitaltTilsyn_client_var.streamStatusCallback('before-graphql-start-stream');
  this.ApiDigitaltTilsyn_client_var.startStream(ApiDigitaltTilsyn_startStream_cameraId_var, ApiDigitaltTilsyn_startStream_profile_var, ApiDigitaltTilsyn_startStream_ttl_var).then((commandResult) => {
    const {
      url,
      id,
      ttl,
    } = commandResult.stream;
    this.bus.emit('api', new Event.StreamStarted_ApiDigitaltTilsynMsg(this.name, 'api', ApiDigitaltTilsyn_startStream_cameraId_var, id, url, ttl));
    this.bus.emit('api', new Event.StreamTtl_ApiDigitaltTilsynMsg(this.name, 'api', ApiDigitaltTilsyn_startStream_cameraId_var, id, ttl));
    this.bus.emit('statusInput', new Event.Duration_StatusMsg(this.name, 'statusInput', Enum.DurationTypes_ENUM.STARTSTREAMMUTATION, this.timestamp() - startedAt_var));
    this.ApiDigitaltTilsyn_client_var.streamStatusCallback('graphql-start-stream');
  }, (error) => {
    this.dispatchError(error);
    this.bus.emit('statusInput', new Event.Duration_StatusMsg(this.name, 'statusInput', Enum.DurationTypes_ENUM.STARTSTREAMMUTATION, this.timestamp() - startedAt_var));
    this.ApiDigitaltTilsyn_client_var.streamStatusCallback('graphql-start-stream-error');
  });
};

ApiDigitaltTilsyn.prototype.keepStreamAlive = function (ApiDigitaltTilsyn_keepStreamAlive_cameraId_var, ApiDigitaltTilsyn_keepStreamAlive_streamId_var, ApiDigitaltTilsyn_keepStreamAlive_ttl_var) {
  if (!(this.check(ApiDigitaltTilsyn_keepStreamAlive_cameraId_var))) {
    return;
  }
  this.ApiDigitaltTilsyn_client_var.keepAlive(ApiDigitaltTilsyn_keepStreamAlive_cameraId_var, ApiDigitaltTilsyn_keepStreamAlive_streamId_var, ApiDigitaltTilsyn_keepStreamAlive_ttl_var).then((commandResult) => {
    const {
      id,
      ttl,
    } = commandResult.stream;
    this.bus.emit('api', new Event.StreamTtl_ApiDigitaltTilsynMsg(this.name, 'api', ApiDigitaltTilsyn_keepStreamAlive_cameraId_var, id, ttl));
  }, (error) => {
    this.dispatchError(error);
  });
};

ApiDigitaltTilsyn.prototype.stopStream = function (ApiDigitaltTilsyn_stopStream_cameraId_var, ApiDigitaltTilsyn_stopStream_streamId_var) {
  if (!(this.check(ApiDigitaltTilsyn_stopStream_cameraId_var))) {
    return;
  }
  this.ApiDigitaltTilsyn_client_var.stopStream(ApiDigitaltTilsyn_stopStream_cameraId_var, ApiDigitaltTilsyn_stopStream_streamId_var).catch((error) => {
    this.bus.emit('api', new Event.ErrorTechnical_ApiDigitaltTilsynMsg(this.name, 'api'));
  });
};

ApiDigitaltTilsyn.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

ApiDigitaltTilsyn.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

ApiDigitaltTilsyn.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

ApiDigitaltTilsyn.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

ApiDigitaltTilsyn.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tclient = ${this.ApiDigitaltTilsyn_client_var}`;
  result += '';
  return result;
};

module.exports = ApiDigitaltTilsyn;
